// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  sessionId: __t.u64().primaryKey().name("session_id"),
  workspaceId: __t.u64().name("workspace_id"),
  executorLane: __t.string().name("executor_lane"),
  harnessVersion: __t.string().name("harness_version"),
  turnId: __t.option(__t.u64()).name("turn_id"),
  status: __t.string(),
  lastHeartbeatAt: __t.i64().name("last_heartbeat_at"),
  createdAt: __t.i64().name("created_at"),
  completedAt: __t.option(__t.i64()).name("completed_at"),
});
